import {
  RecruiterAiInterviewsState,
  AiInterviewInvite
} from "@/store/modules/recruiter_ai_interviews/interfaces";

export default {
  AI_INTERVIEW_INVITES(state: RecruiterAiInterviewsState): AiInterviewInvite[] {
    return state.invites
      .filter((i) => (i.interview_type || "ai") === "ai")
      .sort((a, b) =>
        (b.scheduled_at ?? "").localeCompare(a.scheduled_at ?? "")
      );
  },
  PERSON_INTERVIEW_INVITES(state: RecruiterAiInterviewsState): AiInterviewInvite[] {
    return state.invites
      .filter((i) => i.interview_type === "person")
      .sort((a, b) =>
      (b.scheduled_at ?? "").localeCompare(a.scheduled_at ?? "")
      );
  },
  AI_INTERVIEW_INVITE_BY_ID:
    (state: RecruiterAiInterviewsState): ((id: string) => AiInterviewInvite | null) =>
    (id: string): AiInterviewInvite | null => {
      return state.invites.find((i) => i.id === id) || null;
    }
};

